module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/TravelerSelector/TravelerSelector.module.scss");